import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { LOGO_URL, WA_TATTOO } from "../../lib/constants";

const LINKS = [
  { label: "ESTÚDIO", href: "#manifesto" },
  { label: "PORTFÓLIO", href: "#portfolio" },
  { label: "PIERCING & JOIAS", href: "#piercing" },
  { label: "CONTATO", href: "#orcamento" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 left-0 right-0 z-50 transition-[background-color,border-color] duration-500 ${
        scrolled
          ? "bg-[#0A0A0A]/80 backdrop-blur-xl border-b border-white/10"
          : "bg-transparent border-b border-transparent"
      }`}
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo-link" className="flex items-center gap-3">
          <img src={LOGO_URL} alt="Diggy Shop" className="h-10 w-auto" />
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/[^a-z]/g, "-")}`}
              className="text-xs tracking-[0.2em] font-semibold text-white/70 hover:text-[#E60000] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          href={WA_TATTOO}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="nav-whatsapp-button"
          className="btn-sharp hidden sm:flex items-center gap-2 bg-[#E60000] hover:bg-white hover:text-[#0A0A0A] text-white text-xs tracking-[0.15em] font-bold px-5 py-3 transition-colors duration-300"
        >
          <MessageCircle size={14} />
          WHATSAPP
        </a>
      </div>
    </motion.header>
  );
};
